import { Injectable, makeStateKey, TransferState, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TServiceResult } from '@shared/helper/t-service-result';
import { LocalRepository } from '@shared/helper/local-repository';

import { HttpBaseService } from '@shared/service/base_services/http_base.service';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, debounceTime, switchMap } from 'rxjs/operators';
import { ActivitiesAggrigatorService } from '../activitiesAggrigator.service';
import { BooklistAggrigatorService } from '@app/pages/booklists/services/booklist-aggrigator.service';
import { BookAggrigatorService } from '../bookAggrigator.service';
import { PostAggService } from '@app/pages/posts/services/postAggrigator.service';
import { ReviewsAggrigatorService } from '@app/pages/reviews/services/reviewsAggrigator.service';
import { ShoppingLinkService } from '../Shopping-link/shoppingLink.service';
import { BookResolverData } from '@app/pages/books/resolvers/book-detail.resolver';
import { BookGenresService } from '../bookGenre.service';
import { QuoteAggrigatorService } from '@app/pages/quotes/services/quote-aggrigator.service';
import { WorkService } from '../combineBook.service';
import { ClubAggregatorService } from '@app/pages/clubs/services/club-aggregator.service';
import { BookModel } from '@shared/model/bookModels/book-model';


export const STATE_KEY_BOOK = makeStateKey<BookResolverData>('loaded_book');

@Injectable({
    providedIn: 'root'
})
export class BookDetailsFacadeService extends HttpBaseService {
    private workService = inject(WorkService);
    private serverState = inject(TransferState);
    private postAggService = inject(PostAggService);
    private shopLinkService = inject(ShoppingLinkService);
    private bookGenresService = inject(BookGenresService);
    private bookAggrigatorService = inject(BookAggrigatorService);
    private bookListAggrService = inject(BooklistAggrigatorService);
    private quoteAggrigatorService = inject(QuoteAggrigatorService);
    private reviewsAggrigatorService = inject(ReviewsAggrigatorService);
    private activitiesAggrigatorService = inject(ActivitiesAggrigatorService);
    private clubAggregatorService = inject(ClubAggregatorService);

    shopTermFilter: TermFilterModel = new TermFilterModel();
    listTermFilter: TermFilterModel = new TermFilterModel();
    reviewsTtermFilter: TermFilterModel = new TermFilterModel();
    bookPostsTermFilter: TermFilterModel = new TermFilterModel();
    userActivitiesTermFilter: TermFilterModel = new TermFilterModel();
    quoteTermFilter: TermFilterModel = new TermFilterModel();
    otherEditionTermFilter: TermFilterModel = new TermFilterModel();
    clubTermFilter: TermFilterModel = new TermFilterModel();

    bookId ='';
    constructor() {
        const http = inject(HttpClient);
        const repo = inject(LocalRepository);

        super(repo, http, '');
        this.shopTermFilter.pgNumber = 0;
        this.shopTermFilter.pgSize = 5;
        this.listTermFilter.pgNumber = 0;
        this.listTermFilter.pgSize = 5;
        this.reviewsTtermFilter.pgNumber = 0;
        this.reviewsTtermFilter.pgSize = 20;
        this.bookPostsTermFilter.pgNumber = 0;
        this.bookPostsTermFilter.pgSize = 10;
        this.userActivitiesTermFilter.pgNumber = 0;
        this.userActivitiesTermFilter.pgSize = 1;
        this.quoteTermFilter.pgSize = 4;
        this.quoteTermFilter.pgNumber = 0;
        this.clubTermFilter.pgSize = 4;
        this.clubTermFilter.pgNumber = 0;
        this.otherEditionTermFilter.pgSize = 4;
        this.otherEditionTermFilter.pgNumber = 0;
    }



    resolveBookDetail(bookId: string): Observable<BookResolverData> {
        this.bookId = bookId;

        const brd = this.serverState.get<BookResolverData>(STATE_KEY_BOOK, BookResolverData.instanceAllError());
        if (brd?.book?.hasError == false && brd?.book?.result?.id == this.bookId)
            return of(brd);

        return this.bookAggrigatorService.getBookById(this.bookId)
            .pipe(
                debounceTime(0),// debounce zero is requiered to be glitch-free stream
                switchMap(x =>
                    forkJoin({
                        book: x != undefined ? of(x) : of(new TServiceResult<BookModel>(new BookModel(), '', null, true, '')),
                        bookLists: this.bookListAggrService.getBooklistsOfBook(this.bookId, this.listTermFilter),
                        posts: this.postAggService.getSuggestedPostsByBookId(this.bookId, this.bookPostsTermFilter),
                        myReview: this.reviewsAggrigatorService.getMyReviewOnItem(this.bookId),
                        otherReviews: this.reviewsAggrigatorService.getReviewsOnWork(this.bookId, this.reviewsTtermFilter),
                        // userActivities: this.activitiesAggrigatorService.getMyActivitiesOnBook(this.bookId, this.userActivitiesTermFilter),
                        // ? Data Need WorkId
                        shopLinks: x.result?.workId != undefined ? this.shopLinkService.getByWorkId(x.result.workId, this.shopTermFilter)
                            : of(TServiceResult.fromFailure(null)),
                        genres: x.result?.workId != undefined ? this.bookGenresService.getAllByWorkId(x.result.workId)
                            : of(TServiceResult.fromFailure(null)),
                        quotes: x.result.workId != undefined ? this.quoteAggrigatorService.getQuotesOnWorkByWorkId(x.result.workId, this.quoteTermFilter)
                            : of(TServiceResult.fromFailure(null)),
                        clubs: this.clubAggregatorService.getCoursesByBookId(x.result.id!, this.clubTermFilter),
                        // workBooks: x.result.workId != undefined ? this.workService.getWorkBooksByWorkId(x.result.workId, x.result.id, this.otherEditionTermFilter)
                        //     : of(TServiceResult.fromFailure(null)),
                    })
                ),
                switchMap(forkResult => {
                    const brd = BookResolverData.instance(forkResult);
                    this.serverState.set<BookResolverData>(STATE_KEY_BOOK, brd);
                    return of(brd);
                }),
                catchError(() => {
                    this.serverState.set<BookResolverData>(STATE_KEY_BOOK, BookResolverData.instanceAllError());
                    return of(BookResolverData.instanceAllError());
                })
            )

    }


}
